import React, { useContext } from 'react';
import { Box, Typography } from '@mui/material';
import { gql, useQuery } from '@apollo/client';
import clientGraphql from '../../../common/apollo-graphql';
import AuthContext from '../../auth/context/AuthContext';
import ReferralBarChart from './ReferralBarChart';

const REFERRAL_LIST = gql`
  query ReferralList($startDate: String!, $endDate: String!, $type: String) {
    referral_list(start_date: $startDate, end_date: $endDate, type: $type) {
      name
      referrals
      accepted_referrals
      declined_referrals
    }
  }
`;

export default function ReferralList({ startDate, endDate, type }) {
  const currentUser = useContext(AuthContext);
  const color = '#3498db';
  const label = type === 'sent' ? 'Sent' : 'Received';

  const { data, loading } = useQuery(REFERRAL_LIST, {
    client: clientGraphql,
    variables: {
      type,
      startDate: startDate.format('YYYY-MM-DD'),
      endDate: endDate.format('YYYY-MM-DD'),
    },
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
    skip: !currentUser,
  });

  const referrals = [...(data?.referral_list || [])].sort((a, b) => b.referrals - a.referrals);
  const chartData = referrals.map((row) => {
    const total = Number(row.referrals || 0);
    const accepted = Number(row.accepted_referrals || 0);
    const declined = Number(row.declined_referrals || 0);
    return {
      ...row,
      totalReferrals: total,
      acceptedReferrals: accepted,
      declinedReferrals: declined,
      remainingReferrals: Math.max(total - accepted - declined, 0),
    };
  });
  const totalReferrals = chartData.reduce((sum, row) => sum + Number(row.totalReferrals ?? 0), 0);

  return (
    <Box sx={{ textAlign: 'center' }}>
      <Typography variant="h4" gutterBottom>
        {label} referrals from {startDate.format('MMMM YYYY')} - {endDate.format('MMMM YYYY')}
      </Typography>

      <ReferralBarChart
        referrals={chartData}
        color={color}
        totalLabel={`Total (${totalReferrals})`}
        show={!loading && chartData.length > 0}
        stacked
        baseLabel="Active"
        acceptedLabel="Accepted"
        declinedLabel="Declined"
      />
    </Box>
  );
}
